/** @jsxImportSource @emotion/react */

export default function Logo(props: {
  color: string;
  width?: string;
  className?: string;
}) {
  const { color, width, className } = props;
  return (
    <svg
      className={className}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 108.57"
    >
      <path
        className="cls-1"
        d="M202,87.62l-15.1-64.79a28.64,28.64,0,0,1,10.65-2.41q4.75,0,6.95,2a11,11,0,0,1,2.94,6.26l5.74,27.79q3,14.81,4.38,24.32c.2.8.6,1.21,1.21,1.21l10.42-59.81A63.86,63.86,0,0,1,241,21.32a58.89,58.89,0,0,1,11.47.91l10.43,58.6c.09.8.5,1.21,1.2,1.21q2.73-15.71,4.69-25.53l7.55-34.73a34.09,34.09,0,0,1,9-.91,20.85,20.85,0,0,1,9.14,1.66l.6,1.21L276.94,96.68a88.3,88.3,0,0,1-12.91.76q-7.93,0-10.8-1.81t-3.78-7.7l-3.32-18.58q-3-17.37-4.83-29.9h-.91q-1,7.84-5,29.75l-5.13,27.48a94.34,94.34,0,0,1-13.14.76q-7.86,0-10.8-2T202,87.62Z"
        fill={color}
      />
      <path
        className="cls-1"
        d="M302.76,30.84a18.84,18.84,0,0,1,2.5-5.74,17,17,0,0,1,3.85-4.53q12.22,1.51,16.76,13.59,5.75-13.44,19.18-13.44a35.87,35.87,0,0,1,9.06,1.06,34.42,34.42,0,0,1-4.83,18.42,29.93,29.93,0,0,0-6.95-1.05q-8.76,0-14.19,9.36V96.68a58.62,58.62,0,0,1-9.75.76,64.16,64.16,0,0,1-10-.76V46.39Q308.35,35.68,302.76,30.84Z"
        fill={color}
      />
      <path
        className="cls-1"
        d="M419.35,65.57H377.67q.45,8.31,3.85,13.07t11.86,4.75q8.76,0,20.09-5.13a21.72,21.72,0,0,1,5.58,11.93q-12.07,8.61-29,8.61-16,0-24.24-9.89t-8.23-29.38a59,59,0,0,1,2.11-16.38,36.53,36.53,0,0,1,6.19-12.54,28.29,28.29,0,0,1,10-8.08,30.37,30.37,0,0,1,13.44-2.87A36.57,36.57,0,0,1,402.89,22a27.63,27.63,0,0,1,10,6.65A27.91,27.91,0,0,1,419,38.84a39,39,0,0,1,2,12.84,54.47,54.47,0,0,1-.46,7.17Q420.11,62.26,419.35,65.57ZM390.21,33.86q-11.79,0-12.69,17.82h25.07V49.87q0-7.26-3-11.63T390.21,33.86Z"
        fill={color}
      />
      <path
        className="cls-1"
        d="M496.83,46.24V79.17q0,9.66,3.17,14.34a17.06,17.06,0,0,1-11.63,4.23q-6.5,0-8.91-2.94c-1.61-2-2.42-5.06-2.42-9.29V50.32q0-6.8-1.66-9.51c-1.11-1.82-3.17-2.72-6.19-2.72q-8,0-14.95,7.25V96.68a33.79,33.79,0,0,1-4.76.61c-1.66.1-3.35.15-5.06.15s-3.39,0-5.06-.15a33.65,33.65,0,0,1-4.75-.61V21.93l.9-1.06h7.55q8.46,0,10.58,9.06,11-9.51,21.89-9.51t16.09,7Q496.82,34.46,496.83,46.24Z"
        fill={color}
      />
      <path
        className="cls-1"
        d="M151.81,28.33l-25-6c-3.09-9-8.1-16.29-14.62-19.92C95.35-7,59,13,31.86,25.64A119.25,119.25,0,0,1,0,35.48s22.52,82.66,81.58,72.17c39.64-7,52.26-45.1,48-74ZM59.09,64c-19.34,3-26.72-20.29-26.72-20.29s9.93,2.27,14.94-1.07C55,37.49,63.6,31.72,69.13,34.37,78.14,38.69,78.44,61,59.09,64Zm43.3-37.79a5.72,5.72,0,0,1-6.87-4.24A5.52,5.52,0,1,1,106.15,19,5.71,5.71,0,0,1,102.39,26.16Z"
        fill={color}
      />
    </svg>
  );
}
